/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { InformationCircleIcon, CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { useFormState } from 'react-hook-form';
import { Listbox, Transition } from '@headlessui/react';

dayjs.extend(utc);

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function ConnectedAccount({ index, updateWorkflowStatus, form, signalNext, setSignalNext }) {
  const { t: tS } = useTranslation('app', { keyPrefix: 'schema.pension.account' });
  const { t: tA } = useTranslation('addAccount');

  const selectDepositAccounts = useSelector((state) => state.data.deposits.accounts);

  const { register, watch, setValue, trigger } = form;
  const { errors, isValid } = useFormState({
    control: form.control,
    name: ['connectedDepositMode', 'connectedDepositAccounts'],
  });

  const connectedDepositMode = watch('connectedDepositMode');
  const connectedDepositAccountsSelection = watch('connectedDepositAccounts') || [];

  useEffect(() => {
    register('connectedDepositAccounts');
  }, [register]);

  useEffect(() => {
    updateWorkflowStatus(index, isValid);
  }, [isValid]);

  //--------------------------------------------------------------------------------
  // subscribe to signal from parent that the user has clicked the "next" button
  // (and then trigger all validations to show errors)
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (signalNext) {
      trigger();
      setSignalNext(false);
    }
  }, [signalNext, trigger, setSignalNext]);

  useEffect(() => {
    if (connectedDepositMode !== 'existingAccount') {
      setValue('connectedDepositAccounts', [], { shouldDirty: false });
      return;
    }
    if (!connectedDepositAccountsSelection.length && selectDepositAccounts.length) {
      setValue('connectedDepositAccounts', [selectDepositAccounts[0].id], { shouldDirty: true });
    }
  }, [connectedDepositMode, connectedDepositAccountsSelection, selectDepositAccounts, setValue]);

  //---------------------------------------------------------------------------------------------
  // render the form
  //---------------------------------------------------------------------------------------------

  return (
    <div className="pt-4 sm:pt-0 grid sm:grid-cols-2 gap-4 sm:gap-x-8">
      <div className="sm:col-span-2 mb-4">
        <h3 className="text-xl md:text-2xl font-bold leading-6 text-gray-900">{tA('common.connectedAccounts.title')}</h3>
        <p className="mt-1 pb-4 text-sm text-gray-500">{tA('common.connectedAccounts.subtitle')}</p>
      </div>
      <h4 className="xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900">
        {tA('common.connectedAccounts.whenIBuy', { categorySingle: tS('product'), buyOrSellText: tA('pension.wizardSteps.connectedAccount.buyOrSellText') })}
      </h4>
      <div className="flex items-center">
        <input
          id="existingAccount"
          name="existingAccount"
          type="radio"
          value="existingAccount"
          className="h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
          {...register('connectedDepositMode', { required: { value: true, message: tS('connectedDepositMode.error') } })}
        />
        <label htmlFor="existingAccount" className="ml-3 block text-sm font-medium text-gray-700">
          {tA('common.connectedAccounts.existingAccount')}
        </label>
        {/* if this radio button is selected, display the deposit accounts dropdown */}
      </div>
      {connectedDepositMode === 'existingAccount' && (
        <div className="xl:flex xl:items-center w-full sm:max-w-md">
          <div className="w-full">
            <Listbox value={connectedDepositAccountsSelection} onChange={(values) => setValue('connectedDepositAccounts', values, { shouldDirty: true, shouldValidate: true })} multiple>
              <div className="relative mt-1">
                <Listbox.Button className="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-brandBlue-400 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 sm:text-sm">
                  <span className="block truncate text-gray-700">
                    {connectedDepositAccountsSelection.length
                      ? connectedDepositAccountsSelection
                        .map((id) => selectDepositAccounts.find((account) => account.id === id)?.name)
                        .filter(Boolean)
                        .join(', ')
                      : tA('common.connectedAccounts.existingAccountSelect')}
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </span>
                </Listbox.Button>
                <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                  <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    {selectDepositAccounts.map((account) => (
                      <Listbox.Option
                        key={account.id}
                        className={({ active }) => classNames(active ? 'bg-brandBlue-500 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9')}
                        value={account.id}
                      >
                        {({ selected, active }) => (
                          <>
                            <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>{account.name}</span>
                            {selected ? (
                              <span className={classNames(active ? 'text-white' : 'text-brandBlue-500', 'absolute inset-y-0 right-0 flex items-center pr-4')}>
                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </Listbox>
            <p className="mt-1 text-xs text-gray-500">{tA('common.connectedAccounts.existingAccountSelect')}</p>
          </div>
        </div>
      )}
      <div className="flex items-center col-start-1">
        <input
          id="createAccountLater"
          name="createAccountLater"
          type="radio"
          value="createAccountLater"
          className="h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
          {...register('connectedDepositMode', { required: { value: true, message: tS('connectedDepositMode.error') } })}
        />
        <label htmlFor="createAccountLater" className="ml-3 block text-sm font-medium text-gray-700">
          {tA('common.connectedAccounts.createAccountLater')}
        </label>
      </div>
      {connectedDepositMode === 'createAccountLater' && (
        <div className="flex gap-2 text-sm">
          <InformationCircleIcon className="h-6 w-6 text-brandBlue-500 self-start" aria-hidden="true" />
          {tA('common.connectedAccounts.createAccountLaterDescription', { categorySingle: tS('product') })}
        </div>
      )}
      <p className="col-start-1 mt-2 text-sm text-red-500" id="connectedDepositMode-error">
        {errors.connectedDepositMode && <span>{errors.connectedDepositMode.message}</span>}
      </p>
    </div>
  );
}

ConnectedAccount.propTypes = {
  index: PropTypes.number.isRequired,
  updateWorkflowStatus: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  signalNext: PropTypes.bool,
  setSignalNext: PropTypes.func,
};
ConnectedAccount.defaultProps = {
  signalNext: undefined,
  setSignalNext: () => {},
};

export default ConnectedAccount;
